module.exports = __webpack_public_path__ + "img/login-v2-dark.2885fd8a.svg";